import { Component } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { Router } from "@angular/router";
import { A11yModule } from '@angular/cdk/a11y';
import { TranslatePipe } from "../../pipes/translate.pipe";
import { RtlService } from "../../services/rtl.service";

@Component({
  selector: 'app-camera-instructions',
  standalone: true,
  imports: [
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    A11yModule,
    TranslatePipe,
  ],
  templateUrl: './camera-instructions.component.html',
  styleUrl: './camera-instructions.component.scss',
})
export class CameraInstructionsComponent {
  imgFailed = false;

  constructor(
    private dialogRef: MatDialogRef<CameraInstructionsComponent>,
    private router: Router,
    public rtlService: RtlService
  ) {}

  onImgError(event: Event) {
    this.imgFailed = true;
    (event.target as HTMLImageElement).style.display = 'none';
  }

  submitInstructions() {
    this.dialogRef.close(true);
  }

  closeInstructions() {
    this.router.navigate(['/']);
  }
}
